// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Button } from 'ui'
import ModalDivider from 'projects/components/modal/ModalDivider';
import ExcerptConstants from 'constants/ExcerptConstants';
import Textarea from 'react-textarea-autosize';
import MemoAvatar from './MemoAvatar';
import {
  AVATAR_SIZE
} from 'constants/DimensionsConstants';
import { useMemoDraft } from 'hooks/useMemoDraft';


function AvatarInput(props) {
  const {
    memoText: newInput,
    setMemoText: setNewInput,
    updateMemoText,
    saveDraftNow,
    syncDraftNow
  } = useMemoDraft(props.excerptId);

  function addInput(e) {
    const _newInput = newInput;
    e.preventDefault();
    e.stopPropagation();
    // Flush the draft so the text survives a crash while the request is in flight
    saveDraftNow(_newInput)
    setNewInput('')
    props.addInput(_newInput).then(()=>{
      // Persist whatever the field holds now: clears the draft when it's
      // still empty, but keeps text typed while the request was in flight
      syncDraftNow()
    }).catch((error)=>{
      console.log(error);
      if ( props.handleError ) props.handleError()
      // Restore the submitted text and keep the draft matching what's visible
      setNewInput(_newInput)
      saveDraftNow(_newInput)
    })
  }

  function onKeyDown(e) {
    // if field is currently empty, and the new key is @, then we want to add '@ai ' to the field
    if (newInput.length === 0 && e.key === '@' && props.featureFlagAICoding) {
      e.preventDefault();
      // State-only: don't persist the auto-inserted prefix as a draft the
      // user never typed; the next keystroke persists the full text
      setNewInput('@ai_assistant ')
    }
    else if(e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      addInput(e)
    }
  }
  
  const buttonEnabled = !!newInput && newInput.length > 0;

  return (
    <div>
      <ModalDivider/>
      <form 
        onSubmit={addInput}
        style={{
          marginLeft: ExcerptConstants.PADDING,
          marginRight: ExcerptConstants.PADDING,
          marginBottom: '13px',
          marginTop: '13px',
        }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'row',
        }}>
          <div style={{
            width: AVATAR_SIZE,
            flex: "0 0 auto",
            paddingTop: '6px',
          }}>
            <MemoAvatar 
              initials={props.initials}
              color={props.color}
              />
          </div>
          <div style={{
            flex: 1,
            paddingLeft: '8px',
            alignItems: "center",
            justifyContent: "center",
            display: 'flex',
          }}>
            <Textarea
              placeholder="Enter Memo"
              onChange={(e)=>updateMemoText(e.target.value)}
              onKeyDown={onKeyDown}
              value={newInput}
              style={{
                width: "100%",
                border: "none",
                borderStyle:"none",
                outline:"none",
                resize:'none',
                alignItems: "center",
                justifyContent: "center",    
              }}/>
          </div>
          <div style={{
            display: 'flex',
            "justifyContent": "flex-end",
            "alignItems": "flex-end"
          }}>
            <div style={{
              flex: "0 0 auto"
            }}>
              <Button
                type="submit"
                variant={buttonEnabled ? "blue" : "white" }
                size="small"
                disabled={!buttonEnabled}
                >
                Add Memo
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AvatarInput;